<template>
  <div style="width: 100%; height: 100%; position: relative">
    <div :style="{width:'100%', height:height}" :id="id"></div>
    <!--    <div v-if="this.option.length" class="unit">-->
    <!--      单位：{{ this.unit }}-->
    <!--    </div>-->
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'ChartLine',
  props: {
    id: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    legendDataVal: {
      type: String,
      default: ''
    },
    xNameList: {
      type: Array,
      default () {
        return []
      }
    },
    unit: {
      type: String,
      default: '10 thousand CNY'
    },
    xKeyList: {
      type: Array,
      default () {
        return []
      }
    },
    option: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      dataZoomConfig: [
        {
          type: 'inside',
          start: 0,
          end: 49.99
        },
        {
          type: 'slider'
        }
      ]
    }
  },
  methods: {},
  watch: {
    option: {
      handler (newVal) {
        if (newVal.length) {
          const seriesData = []
          newVal.forEach(item => {
            const _data = []
            this.xKeyList.forEach(xItem => {
              _data.push(item[xItem])
            })
            seriesData.push({
              name: item[this.legendDataVal],
              type: 'line',
              symbol: 'circle',
              smooth: true,
              data: _data
            })
          })

          const chart = echarts.init(document.getElementById(this.id))
          const option = {
            color: ['#5D88F9', '#78BDEE', '#71DBC6', '#FDAE59', '#FC83A7', '#DC4E78'],
            title: {},
            tooltip: {
              backgroundColor: 'rgba(255,255,255,0)',
              position: 'top',
              formatter: (params) => {
                return `
                  <div style="position: relative;">
                      <div
                          style="background: #fff; padding: 8px 15px; border-radius: 4px; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);">
                          <p style="margin: 0; color: #000; font-size: 14px;">${params.name}</p>
                          <p style="margin: 0; color: #000; font-size: 12px;">
                              ${params.seriesName}:
                              <span style="color: #409EFF">
                                  ${params.value}
                              </span>
                              ${this.unit}
                          </p>
                      </div>
                      <div style="position: absolute; bottom: 0; left: 0; width: 100%; z-index: 3; height: 10px; background: #fff; border-radius: 4px;"></div>
                      <div style="position: absolute; bottom: -5px; left: 50%; z-index: 2; margin-left: -5px; width: 10px; height: 10px; background: #fff; transform: rotate(135deg); box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);"></div>
                  </div>
                `
              }
            },
            legend: {
              icon: 'circle',
              itemWidth: 10,
              itemHeight: 10,
              itemGap: 25,
              bottom: '10px',
              textStyle: {
                fontSize: '12px',
                color: 'rgba(0, 0, 0, 0.8)',
                padding: [3, 0, 0, 8]
              }
            },
            grid: {
              left: '35px',
              right: '20px',
              top: '25px',
              bottom: '45px',
              containLabel: true
            },
            xAxis: {
              data: this.xNameList,
              type: 'category',
              axisLabel: {
                color: '#000',
              },
              splitLine: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              }
            },
            yAxis: {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: ['#EBEBEB']
                }
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              // name: this.unit,
              nameGap: 10
            },
            series: seriesData
          }
          chart.setOption(option)

          // chart.on('mouseover', function (params) {// 鼠标移入
          //   chart.setOption({
          //     series: {
          //       name: params.seriesName,
          //       symbolSize: 8,
          //       lineStyle: {
          //         width: 4,
          //         shadowColor: 'rgba(0, 0, 0, 0.2)',
          //         shadowBlur: 4
          //       }
          //     }
          //   })
          // })
          // chart.on('mouseout', function (params) {// 鼠标移入
          //   chart.setOption({
          //     series: {
          //       name: params.seriesName,
          //       symbolSize: 4,
          //       lineStyle: {
          //         width: 2,
          //         shadowBlur: 0
          //       }
          //     }
          //   })
          // })

        }
      }
    }
  },
  mounted(){
    window.addEventListener('resize', () => {
      const chart = echarts.init(document.getElementById(this.id))
      chart.resize()
    }) 
 }
}
</script>

<style scoped>
.unit {
  position: absolute;
  top: 10px;
  right: 35px;
  font-size: 12px;
  color: #717982;
}
</style>
